import axios from 'axios';
import HdlToast from '@/utils/toast';
import errorHandle from '@/utils/errorHandle';
import { isEnv, getDeviceIds } from '@/utils';
import { getToken } from '@/helper/user';
import { Login } from '@/helper/user';
const baseURL: string = process.env.NODE_ENV === 'production' ? '/' : '/api';
const service = axios.create({
  baseURL,
  timeout: 10000,
  withCredentials: true,
});

let TOKEN = '', //token
  DEVICED: any = null; //设备id
service.interceptors.request.use(async (config: any) => {
  if (!TOKEN) TOKEN = await getToken();
  if (!DEVICED && isEnv() === 'App') DEVICED = await getDeviceIds();
  config.headers = {
    ...config.headers,
    'Content-Type': 'application/json',
    ReqType: 'APPH5',
    deviceId: DEVICED,
    _HAIDILAO_APP_TOKEN: TOKEN,
  };
  return config;
});

service.interceptors.response.use(
  (response) => {
    const {
      data: { code, data, msg },
    } = response;
    //成功
    if (code === 'ok') {
      return data;
    }
    // 异常
    switch (code) {
      case '-1': // 签到活动结束 不需要toast
        return Promise.reject(response);
      case '303004': // 登录超时
      case '303003': // 登录超时
      case '302011': // 登录超时
      case '401': // 登录超时
        Login();
        return Promise.reject(response);
      default:
        HdlToast.info(msg);
        return Promise.reject(response);
    }
  },
  (error) => {
    errorHandle(error);
    return Promise.reject(error);
  },
);
export default service;
